<template>
  <div class="view-box" v-if="props.primitive">
    <span v-if="isView">{{ props.primitive }}</span>
    <span v-else>{{ hideNum(props.primitive) }}</span>
    <div style="color: #409eff;cursor: pointer;" v-if="showEye"  @click="handleView()">
      <el-icon v-if="isView"><View /></el-icon>
      <el-icon v-else><Hide /></el-icon>
    </div>
  </div>
</template>

<script setup>
// 前端假眼睛组件
const props = defineProps({
  primitive:{
    type:String,
    default:'',
    require:true
  },
  showEye:{
    type:Boolean,
    default:true
  }
})
const isView = ref(false);
const handleView = () =>{
  isView.value = !isView.value;
}
//星号隐藏数字
function hideNum(val) {
  if (!val) return;
  let str = val.toString().replace(/(\d{3})(\d*)(\w{4})/, (match, p1, p2, p3) => {
    let length = p2.toString().length;
    let hideStr = '*'.repeat(length);
    return p1 + hideStr + p3;
  });
  return str;
}
</script>

<style lang="scss" scoped>
.view-box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  //min-width: 200px;
}
</style>
